<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" :mensagem="msgAlerta" />

    <div class="form-edit-page row-space">
        <div class="row-start">
            <div class="form-item-char30"><MesSelect :ckAddTodos="true" v-model:opcaoSelecionada="mesSelecionado" /></div>
            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { genericReport } from '@/funcoes/api';
import { globalStore } from '@/globals';
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import MesSelect from '@/selects/estaticos/MesSelect.vue';

const emit=defineEmits(['close']);

const msgAlerta = ref(null);
const isLoading = ref(false);
const mesSelecionado = ref(0);

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            nmrelatorio: 'gabAniversariantes',
            idmunicipio: globalStore.idmunicipio,
            intp1: mesSelecionado.value,
            idusuario: globalStore.idusuario};
        const response = await genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>